import React, { FC } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../utils/Colors';

export type ToastTypes = 'SUCCESS' | 'ERROR' | 'INFO' | 'WARNING';

const Root = styled.div`
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    max-width: 350px;
    min-width: 150px;
    display: flex;
    gap: 10px;
    align-content: center;
    border-radius: 8px;
`;

const Message = styled.span`
    color: ${COLORS.DULL};
    font-size: 14px;
    font-weight: 500;
    padding: 10px;
    flex: 1;
`;

const Button = styled.button`
    background: transparent;
    border: none;
    color: ${COLORS.DULL};
`;

interface Props {
  type?: ToastTypes;
  message?: string;
  onClose: VoidFunction;
}

export const Toast: FC<Props> = ({
  type = 'INFO',
  message,
  onClose,
}) => {
  const backgroundColor = () => {
    switch (type) {
      case 'SUCCESS':
        return COLORS.GREEN;
      case 'ERROR':
        return COLORS.RED;
      case 'INFO':
        return COLORS.BLUE;
      case 'WARNING':
        return COLORS.ORANGE;
      default:
        return COLORS.BLUE;
    }
  };
  return (
    <Root style={{ backgroundColor: backgroundColor() }}>
      <Message>{message}</Message>
      <Button type="button" onClick={onClose}>
        <i className="fa-solid fa-circle-xmark" />
      </Button>
    </Root>
  );
};
